$ = jQuery;

class scrollDirectionDetector {

  constructor() {
    this._vPosition = window.pageYOffset;
  }

  updateVPosition(currentPosition) {
    this._vPosition = currentPosition;
  }

  scrollDirection() {
    let currentPosition = window.pageYOffset;
    if (this._vPosition <= currentPosition) {
      this.updateVPosition(currentPosition);
      return 1;
    } else {
      this.updateVPosition(currentPosition);
      return 0;
    }
  }

}

window.addEventListener('load', function() {

  if (document.getElementById('bg-slant') == undefined) {return}
  let para = new parallaxMe('bg-slant', 750, new scrollDirectionDetector());

    window.addEventListener('scroll', function() {
      para.doParallax();
    });

    window.addEventListener('resize', function() {
      para.resetPos();
    });

});

class parallaxMe {

  constructor(targetObj, vRange, scrollDirFunc) {
    this._scrollDir = scrollDirFunc;
    this._parallaxObj = {
      elem: document.getElementById(targetObj),
      yOffset: parseInt(document.getElementById(targetObj).style.top),
    }
    this._rules = {
      verticalRange: vRange || 500,
    }
    this._triggerZone = {
      start: this._parallaxObj.yOffset - this._rules.verticalRange,
      end: this._parallaxObj.yOffset + this._rules.verticalRange
    }
  }

  doParallax() {
    if (this._scrollDir.scrollDirection()) {
      this._moveUp();
    } else {
      this._moveDown();
    }
  }

  resetPos() {
    this._parallaxObj.yOffset = parseInt(this._parallaxObj.elem.style.top);
    this._triggerZone.start   = this._parallaxObj.yOffset - this._rules.verticalRange;
    this._triggerZone.end     = this._parallaxObj.yOffset + this._rules.verticalRange;
  }

  _moveDown() {
    if (this._parallaxObj.yOffset >= this._triggerZone.end|| window.pageYOffset >= this._triggerZone.end ) {return}
    this._parallaxObj.yOffset += 2;
    this._parallaxObj.elem.style.top = this._parallaxObj.yOffset + 'px';
  }

  _moveUp() {
    if (window.pageYOffset <= this._triggerZone.start || this._parallaxObj.yOffset <= this._triggerZone.start) {return}
    this._parallaxObj.yOffset -= 2;
    this._parallaxObj.elem.style.top = this._parallaxObj.yOffset + 'px';
  }

  // tofix: get window.pageYOffset and make +- change proportional
  // _calcTranslation() {
  //   let pageDelta = window.pageYOffset - this._triggerZone.start;
  //   return pageDelta > 0 ? pageDelta : null;
  // }

}
